/**
 * PlaygroundSLOrbPlaygroundRoute
 *
 * Page component for PlaygroundSLOrbPlaygroundRoute
 * Path: /sl/playground
 *
 * @generated from schema
 */

import React from 'react';
import { useLocation } from 'react-router-dom';
import type { EventPayload } from '@almadar/core';
import { PlaygroundSLOrbPlaygroundPageView as __PlaygroundSLOrbPlaygroundPageView } from '@/components/traits/PlaygroundSLOrbPlaygroundPageView';
import { PlaygroundSLOrbPlaygroundAnalyticsView as __PlaygroundSLOrbPlaygroundAnalyticsView } from '@/components/traits/PlaygroundSLOrbPlaygroundAnalyticsView';
import { VStack, UISlotComponent } from '@almadar/ui/components';
import { SharedEntityStoreContext, useSharedEntityStore, usePageHead } from '@almadar/ui/hooks';

interface PlaygroundSLOrbPlaygroundRouteProps {
  // Add any page-level props here
}

export function PlaygroundSLOrbPlaygroundRoute(_props: PlaygroundSLOrbPlaygroundRouteProps) {
  const __location = useLocation();
  const __navState = (__location.state ?? {}) as EventPayload;

  usePageHead({ "title":["i18n/t","std-orb-playground:meta.title"],"description":["i18n/t","std-orb-playground:meta.description"],"access":"public","indexing":"index","origin":"https://orb.almadar.io","siteName":"Orb","alternates":[{"locale":"en","path":"/playground"},{"locale":"ar","path":"/ar/playground"},{"locale":"sl","path":"/sl/playground"}],"defaultLocale":"en", path: __location.pathname });

  const _sharedStore = useSharedEntityStore();

  return (
    <SharedEntityStoreContext.Provider value={_sharedStore}>
      <UISlotComponent slot="main">
        <VStack gap="lg" className="w-full">
          <__PlaygroundSLOrbPlaygroundPageView config={{ initPayload: __navState }} />
          <__PlaygroundSLOrbPlaygroundAnalyticsView config={{ initPayload: __navState }} />
        </VStack>
      </UISlotComponent>
    </SharedEntityStoreContext.Provider>
  );
}

export default PlaygroundSLOrbPlaygroundRoute;
